<template>
    <!-- <div class="banner">
      <img
        class="banner_bg"
        :src="require('@/assets/images/bg/bg_2.jpg')"
        @load="$emit('change',true)"
        :style="isMobile ? 'width: 100vw;' : 'height: 100vh;width: 100vw'"
      />
      <el-image  :src="require('@/assets/images/bg/bg_1.jpg')" style="width:100vw;height:100vh"  fit="fill"></el-image>
        <span class="banner_txt animate__animated animate__fadeInDown" v-if="show">
        <img :src="require('@/assets/images/banner_txt2.png')"/>
        </span>
    </div> -->
  <!-- <el-carousel height="150px">
      <el-carousel-item v-for="item in img" :key="item">
        
      </el-carousel-item>
    </el-carousel> -->

  <swiper :options="swiperOption"  @slideChange="onSlideChange" class="czp">
    <!-- <swiper-slide class="banner">
      <el-image  :src="require('@/assets/images/bg/bg_2.jpg')" width='100vw' height='100vh'></el-image>
      <span class="banner_txt2 animate__animated animate__fadeInDown" v-if="activeIndex==0">
        <img :src="require('@/assets/images/banner_txt2.png')"/>
      </span>
    </swiper-slide> -->
    <swiper-slide v-for="(item,index) in images" :key="index" class="banner">
      <el-image  :src="item.bgImage" width='100vw' height='100vh'></el-image>
      <span :class="item.class" v-if="activeIndex==index">
        <img :src="item.bgTxt"/>
      </span>
    </swiper-slide>
    
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { isMobile } from "@/utils";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        direction: "horizontal",
        loop: false,
        // autoplay: {
        //   delay: 8000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
      },
      isMobile: isMobile(),
      activeIndex: 0,
      images:[]
    };
  },
  created(){
    this.images = [
      {
        bgImage:require('@/assets/images/bg/bg_3.jpg'),
        bgTxt:require('@/assets/images/banner_txt3.png'),
        class:'banner_txt3 animate__animated animate__fadeInDown'
      },
      // {
      //   bgImage:require('@/assets/images/bg/bg_2.jpg'),
      //   bgTxt:require('@/assets/images/banner_txt2.png'),
      //   class:'banner_txt2 animate__animated animate__fadeInDown'
      // },
      {
        bgImage:require('@/assets/images/bg/bg_1.jpg'),
        bgTxt:require('@/assets/images/banner_txt1_new.png'),
        class:'banner_txt animate__animated animate__fadeInDown'
      }
      
    ]
  },
  directives: {
    swiper: directive,
  },
  components: {
    swiper,
    swiperSlide,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods:{
    onSlideChange(){
      const c_swiper = document.getElementsByClassName("czp")
      this.activeIndex = c_swiper[0].swiper.activeIndex
    },
  }
};
</script>

<style lang="scss" scoped>
.czp {
  // height: 100vh;
  width: 100vw;
}
.banner {
  overflow: hidden;
  // width: 100vw !important;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &_txt {
    position: absolute;
    font-size: 72px;
    font-family: PingFang SC;
    // font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 96px;
    text-shadow: 0px 1px 15px rgba(88, 60, 70, 0.15);
  }
  &_bg {
    // height: 100vh;
    // width: 100vw !important;
  }
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
    background: rgb(238, 231, 231);

  }

  .swiper-pagination >>> .swiper-pagination-bullet {
    // background: white;
    height: 10px;
    width: 10px;
  }

  .banner_txt2{
    position: absolute;
    margin-top: 35%;
  }

  .banner_txt3{
    position: absolute;
    margin-top: 0%;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/components/banner/index.vue